import { render } from "./AccordionDocumentiNomina.vue?vue&type=template&id=9625907e"
import script from "./AccordionDocumentiNomina.vue?vue&type=script&lang=js"
export * from "./AccordionDocumentiNomina.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__